module.exports = __webpack_public_path__ + "static/media/forward-arrow-icon.530167fe.png";